import { RecipeDetailsPageProps, WithGlobalData } from '@domains/view';

import { BFFCookieClientClass } from '@api/client/bff';
import { RecipeDetailsPayload, RecipeDetailsResult } from '@api/protocol';

import { RecipeView } from '@views/RecipeView/RecipeView';

type QueryParams = {
    slug: string;
};

export const getServerSideProps: BFF.GetPageServerSideProps<
    WithGlobalData<RecipeDetailsPageProps>,
    QueryParams
> = async (context) => {
    const { req, query } = context;
    const recipe_slug = query?.slug ?? '';

    return BFFCookieClientClass<RecipeDetailsPageProps>({
        isNotFoundOnErrorShown: true,
        request: req,
    })
        .addToStack<RecipeDetailsPayload, RecipeDetailsResult>({
            prop: 'data',
            url: '/api/recipes/details',
            payload: { recipe_slug },
        })
        .getServerProps();
};

export default RecipeView;
